import connectionProxy from './connectionProxy'

export const getCertificateControls = (
  areaId, 
  page = 1, 
  rowsPerPage = 10, 
  orderBy = "name", 
  order = "asc"
) => 
  connectionProxy.http.get(
    `/certificados?area_id=${areaId}&page=${page}&per_page=${rowsPerPage}&order_by=${orderBy}&order=${order}`
  )

export const getSearchCertificateControls = (
  term, 
  areaId, 
  page = 1, 
  rowsPerPage = 10, 
  orderBy = "name", 
  order = "asc"
) => {
  const text = encodeURIComponent(term)
  return connectionProxy.http.get(
    `/certificados/buscar?term=${text}&area_id=${areaId}&page=${page}&per_page=${rowsPerPage}&order_by=${orderBy}&order=${order}`
  )
}

export const downloadXls = (text, areaId) =>
  connectionProxy.http.get(`/certificados/download?term=${text}&area_id=${areaId}`,  {
    responseType: 'arraybuffer'
  });



// WEBPACK FOOTER //
// ./src/api/certificateControls.js